import { ApiService } from 'common/services';

class BrandsService extends ApiService {
  getBrands = () => {
    return this.get('/api/brands?no_limit=true&light=true');
  };
}

export const brandsService = new BrandsService(process.env.REACT_APP_API_URL);
